type BannerTextProps = {
    children: React.ReactNode;
};

export default function BannerText({ children }: BannerTextProps) {
    return (
        <p className='font-light text-white text-lg md:text-xl lg:text-2xl'>
            {children}
        </p>
    );
}
